import { useEffect, useState } from 'react';
import { AnalyticsStorageKeys } from './constants';
import { AnalyticsStorage } from './utils';
var getAnalyticsStorageParams = function () {
    return Object.values(AnalyticsStorageKeys).reduce(function (acc, current) {
        var currentParamValue = AnalyticsStorage.getValue(current);
        if (currentParamValue) {
            acc[current] = currentParamValue;
            return acc;
        }
        return acc;
    }, {});
};
export var useAnalyticsStorageParams = function (dep) {
    var _a = useState(getAnalyticsStorageParams()), analyticsStorageParams = _a[0], setAnalyticsStorageParams = _a[1];
    var removeAnalyticsStorageParams = function () {
        Object.keys(analyticsStorageParams).forEach(function (param) {
            return AnalyticsStorage.removeItem(param);
        });
        setAnalyticsStorageParams({});
    };
    // biome-ignore lint/correctness/useExhaustiveDependencies: useExhaustiveDependencies
    useEffect(function () {
        var newAnalyticsStorageParams = getAnalyticsStorageParams();
        setAnalyticsStorageParams(newAnalyticsStorageParams);
    }, [dep]);
    return {
        analyticsStorageParams: analyticsStorageParams,
        resetAnalyticsParams: removeAnalyticsStorageParams,
    };
};
